'use strict';
var constants = require('../constants'),
    getLocale = require('./locale');

function hasColor(color) {
    return (constants.CHECKOUT_COLORS.indexOf(color) > -1);
}

function localeSupported(loc) {
    return (constants.CHECKOUT_NEW_UNSUPPORTED_LOCALES.indexOf(loc) === -1);
}

function hasShape(shape) {
    return (constants.BUTTON_SHAPES.indexOf(shape) > -1);
}

function getStyle(color, locale) {
    return (localeSupported(locale)) ? 'checkout' : 'tertiary';
}

function getColor(color, locale) {
    if (!color && getStyle(color, locale) === 'checkout') {
        return constants.DEFAULT_CHECKOUT_COLOR;
    }
    if (!color) {
        return undefined;
    }
    color = color.toLowerCase();
    return (hasColor(color)) ? color : constants.DEFAULT_CHECKOUT_COLOR;
}

function getSize(dataSize, locale) {
    var defaultSize = 'small',
        lowerSize = (localeSupported(locale) && dataSize) ? dataSize.toLowerCase() : defaultSize,
        hasSize = (constants.CHECKOUT_SIZES.indexOf(lowerSize) > -1);
    return hasSize ? lowerSize : defaultSize;
}

function getLabel(size, data) {
    var newLabel = (size.toLowerCase() === 'tiny') ? '{wordmark}' : data.get('label');
    return newLabel;
}

function getShape(shape) {
    shape = shape && shape.toLowerCase();
    return (hasShape(shape)) ? shape : constants.DEFAULT_SHAPE;
}

function getConfig(label, data, config, locale) {
    var color = data.get('color'),
        buttonSize = data.get('size') || config.size,
        shape = data.get('shape') || config.shape,
        loc = getLocale(locale, data.get('lc'));
    var configUpdate = {
        size: getSize(buttonSize, locale),
        style: getStyle(color, loc),
        color: getColor(color, loc),
        shape: getShape(shape),
        tagLabel: (data.get('tagline') === 'false') ? '' : constants.STRINGS[loc][label + '_tag']
    };
    return configUpdate;
}
exports.getConfig = getConfig;
exports.getStyle = getStyle;
exports.localeSupported = localeSupported;
exports.getLabel = getLabel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/checkout-config.js
 ** module id = 10
 ** module chunks = 0
 **/